module.exports = __WEBPACK_EXTERNAL_MODULE_54__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","subWeeks"],"commonjs":"date-fns/sub_weeks/index","commonjs2":"date-fns/sub_weeks/index","amd":"date-fns/sub_weeks/index"}
// module id = 54
// module chunks = 0